import styled from 'styled-components';
import { OptimusTextKey, useLocalization } from '@optimus-web/localization';
import { Container } from '../../../Container';
import { Typography } from '../../../typography';

const EmptyStateContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    flex-grow: 1;
`;

export interface EmptyStateProps {
    emptyMessage: React.ReactNode;
}

export const EmptyState = ({ emptyMessage }: EmptyStateProps) => {
    const { t } = useLocalization();
    return (
        <Container padding={['250', '250']} data-test-id="select-list-empty-state" height="100%">
            <EmptyStateContent>
                <Typography textStyle="bodyMedium" as="div">
                    {emptyMessage ?? t(OptimusTextKey.SelectEmptyMessage)}
                </Typography>
            </EmptyStateContent>
        </Container>
    );
};
